import {Injectable} from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import {Observable, of} from 'rxjs';
import {GenericListService} from '@app/components/lists/generic-reference-list/generic-list.service';
import {refType, refTypes} from '../../../../@shared/_referencesLists/reference-lists/references-status.service';

@Injectable({
  providedIn: 'root'
})
export class GenericListResolver  {

  constructor(
    private genericListService: GenericListService,
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    switch (route.routeConfig.path) {
      case 'referenceList/:listType':

        const {listType} = route.params;
        if (refTypes.includes(listType)) {
          // this.genericListService = new GenericListService(new OrganizationsForGenericListService());
          this.genericListService.setRefType(listType as refType);
          // console.log('Resolver [params]:', route.params.type);
          return of(true);

        } else {
          return of(false);
        }

      default:
        return of(true);
    }

  }
}
